import { atom } from "jotai";

// Create an atom for user data
export const chatInput = atom(""); // or use an initial value if needed
